import type { PropsWithChildren } from 'react';
import React from 'react';
import PropTypes from 'prop-types';

export function EngagementProviderComponent(props: PropsWithChildren<{}>): React.JSX.Element {
	return <>{props.children}</>;
}
export declare namespace EngagementProviderComponent {
	export let propTypes: {
		children: PropTypes.Requireable<PropTypes.ReactElementLike>;
		locale: PropTypes.Requireable<string>;
	};
}

EngagementProviderComponent.propTypes = {
	children: PropTypes.element,
	locale: PropTypes.string,
};
